/************************************************************************
 ** IBM Confidential
 **
 ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
 **
 ** (C) Copyright IBM Corp. 2024
 **
 ** The source code for this program is not published or otherwise divested of its trade secrets, 
 ** irrespective of what has been deposited with the U.S. Copyright Office.
 ************************************************************************/
// GENERATED
import Enum from './Enum';
//@import Enum (loadtime) // superclass

/**
 * <p>Java class for keyCompositionType. <p>The following schema fragment specifies the expected content contained within this class. <p> <pre> &lt;simpleType name="keyCompositionType"&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}string"&gt; &lt;enumeration value="useParent"/&gt; &lt;enumeration value="independent"/&gt; &lt;/restriction&gt; &lt;/simpleType&gt; </pre>
 */
export default class KeyCompositionType extends Enum{

	enumValue = null;

	static  USE_PARENT = KeyCompositionType.newLiteral("useParent");

	static  INDEPENDENT = KeyCompositionType.newLiteral("independent");



	constructor(v) {
		super(v);
		this.enumValue = v;
	}

	static fromValue(v) {
		for (var i = 0; (i < KeyCompositionType.values().length); ++i) {
			if (KeyCompositionType.values()[i].enumValue == v) {
				return KeyCompositionType.values()[i];
			}
		}
		throw new Error(v);
	}

	value() {
		return this.enumValue;
	}

	getResourceId() {
		return (("KeyCompositionType" + "_") + this.value());
	}
}


// WEBPACK FOOTER //
// ./src/generated/KeyCompositionType.js